"use strict";


var _               = require('underscore');
var ItemAttributes  = require('bunsen/collections/inventory/ItemAttributes');
var ItemAttribute   = require('bunsen/models/inventory/ItemAttribute');
var Attributes      = require('bunsen/collections/inventory/Attributes');

/**
 * @class ItemAttributesPeriod
 * @extends ItemAttributes
 */
var ItemAttributesPeriod = module.exports = ItemAttributes.extend();

//TODO Remove this logic from FE once BE has the ability to map certain attribute values to other attributes
var valid21stCenturyLabels = [
    '21st-century-and-contemporary', //21st Century
    'early-2000s', //2000-2009
    '2010s'  //2010-
];

_.extend(ItemAttributesPeriod.prototype, {

    /**
     * Returns true if this attribute is part of the 21st century group
     * Note:    Since attribute value IDs aren't constant, we're using the urlLabel (also not constant, but apparently more
     *          constant than the ID) find the appropriate id.
     *
     * @param  {Attributes} periods A collection containing groups of attribute period values to be used for reference
     * @return {Boolean}            True if this attribute is 21st century
     */
    is21stCentury: function (periods) {
        // this is used in validations, so if we have some attribute values passed from the validator then use them, otherwise create from server vars
        var attrCollection = (periods && new Attributes(periods)) || Attributes.getCollectionForKey(ItemAttribute.ATTRIBUTE_PERIOD);
        var attrs = attrCollection.getItemAttributesCollection({
            comparator: 'option.id'
        });
        var valid21stCenturyIds = attrs
            .filter(function (attr) {
                return _.contains(valid21stCenturyLabels, attr.get('option.urlLabel'));
            })
            .map(function (attr) {
                return attr.get('option.id');
            });

        var periodId = this.at(0) && this.at(0).get('option.id');
        return _.contains(valid21stCenturyIds, parseInt(periodId, 10));
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/inventory/ItemAttributesPeriod.js
// module id = 2624
// module chunks = 63